import React from "react";
import {
  MdHome, MdShoppingCart, MdRestaurantMenu,
  MdAccessTime, MdStar, MdBarChart, MdLock, MdHistory, MdReceiptLong,
} from "react-icons/md";

import Dashboard from "views/admin/default";
import Orders from "views/admin/orders";
import History from "views/admin/history";
import Invoices from "views/admin/invoices";
import Menu from "views/admin/menu";
import Schedule from "views/admin/schedule";
import Reviews from "views/admin/reviews";
import Stats from "views/admin/stats";
import SignIn from "views/auth/SignIn";

const routes = [
  {
    name: "Tableau de bord",
    layout: "/admin",
    path: "dashboard",
    icon: <MdHome className="h-6 w-6" />,
    component: <Dashboard />,
  },
  {
    name: "Commandes",
    layout: "/admin",
    path: "orders",
    icon: <MdShoppingCart className="h-6 w-6" />,
    component: <Orders />,
  },
  {
    name: "Historique",
    layout: "/admin",
    path: "history",
    icon: <MdHistory className="h-6 w-6" />,
    component: <History />,
  },
  {
    name: "Mes factures",
    layout: "/admin",
    path: "invoices",
    icon: <MdReceiptLong className="h-6 w-6" />,
    component: <Invoices />,
  },
  {
    name: "Menu",
    layout: "/admin",
    path: "menu",
    icon: <MdRestaurantMenu className="h-6 w-6" />,
    component: <Menu />,
  },
  {
    name: "Horaires",
    layout: "/admin",
    path: "schedule",
    icon: <MdAccessTime className="h-6 w-6" />,
    component: <Schedule />,
  },
  {
    name: "Avis clients",
    layout: "/admin",
    path: "reviews",
    icon: <MdStar className="h-6 w-6" />,
    component: <Reviews />,
  },
  {
    name: "Statistiques",
    layout: "/admin",
    path: "stats",
    icon: <MdBarChart className="h-6 w-6" />,
    component: <Stats />,
  },
  {
    name: "Connexion",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
];

export default routes;
